import React from "react";
import {Paper, Typography} from "@mui/material";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

export default function ServerStatsChart({ stats }) {
    if (!stats || stats.length === 0) {
        return (<Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Графики нагрузки</Typography>
            <Typography>Нет данных для отображения</Typography>
        </Paper>)
    }
    return(
        <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Графики нагрузки</Typography>

            <ResponsiveContainer width="100%" height={200}>
                <LineChart data={stats}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time" />
                    <YAxis yAxisId="left" domain={[0, 100]} />
                    <YAxis yAxisId="right" orientation="right" domain={[0, 64]} />
                    <Tooltip
                        content={({ active, payload }) => {
                            if (active && payload && payload.length) {
                                const point = payload[0].payload;
                                return (
                                    <Paper elevation={3} sx={{ p: 1 }}>
                                        <Typography variant="body2" fontWeight="bold">{point.fullTime}</Typography>
                                        <Typography variant="body2">CPU: {point.cpu.toFixed(2)}%</Typography>
                                        <Typography variant="body2">Память: {point.memory.toFixed(2)} ГБ</Typography>
                                    </Paper>
                                );
                            }
                            return null;
                        }}
                    />
                    <Legend />
                    <Line yAxisId="left" type="monotone" dataKey="cpu" stroke="#8884d8" dot={false} name="CPU (%)" />
                    <Line yAxisId="right" type="monotone" dataKey="memory" stroke="#82ca9d" dot={false} name="Память (ГБ)" />
                </LineChart>
            </ResponsiveContainer>
        </Paper>
    );
}